import { Button, Card, Modal, ModalBody, Text } from "@wojo/ui";
import React, { useState } from "react";
import styles from "./EntryRequirementsInclusion.module.scss";
import { EntryRequirementsInclusionDetail } from "./EntryRequirementsInclusionDetail";
import { SherpaInclusion } from "./SherpaInclusion";

export type EntryRequirementsInclusionProps = {
    icon?: React.ReactNode;
    inclusion: SherpaInclusion;
    title: string;
};

export const EntryRequirementsInclusion: React.FC<
    EntryRequirementsInclusionProps
> = ({ icon, inclusion, title }) => {
    const [open, setOpen] = useState(false);

    return (
        <>
            <Card
                className={styles.inclusion}
                tag="button"
                onClick={() => setOpen(true)}
            >
                <div className={styles.heading}>
                    <Text.Body emphasis="2">{title}</Text.Body>
                    {icon}
                </div>
                {!!inclusion.attributes.title && (
                    <Text.Body className={styles.description}>
                        {inclusion.attributes.title}
                    </Text.Body>
                )}
                <Button className={styles.button} variant="quiet" tag="span">
                    View details
                </Button>
            </Card>
            <Modal
                accessibleTitle={title}
                isOpen={open}
                onCloseRequested={() => setOpen(false)}
            >
                <ModalBody>
                    <EntryRequirementsInclusionDetail inclusion={inclusion} />
                </ModalBody>
            </Modal>
        </>
    );
};

const IGNORED_CATEGORIES = ["QUARANTINE", "NO_QUARANTINE", "SANITIZATION"];
const IGNORED_ENFORCEMENTS = ["NOT_REQUIRED", "OPTIONAL", "RECOMMENDED"];
const IGNORED_SUBCATEGORIES = ["IN_AIRPORT", "IN_FLIGHT"];
const BASIC_DOCUMENTS = ["COVID_TEST_RESULT", "COVID_19_VACCINATION"];

export type Inclusion = "PPE" | "Test" | "BasicDocs" | "AdditionalDocs" | null;

export const categorizeInclusion = (inclusion: SherpaInclusion): Inclusion => {
    if (
        IGNORED_CATEGORIES.includes(inclusion.attributes.category || "") ||
        IGNORED_ENFORCEMENTS.includes(inclusion.attributes.enforcement || "") ||
        IGNORED_SUBCATEGORIES.includes(inclusion.attributes.subCategory || "")
    ) {
        return null;
    }
    if (inclusion.attributes.category === "PPE") {
        return "PPE";
    }
    if (inclusion.attributes.category === "COVID_19_TEST") {
        return "Test";
    }
    if (
        inclusion.attributes.category === "DOC_REQUIRED" &&
        inclusion.attributes.documentType?.some((document) =>
            BASIC_DOCUMENTS.includes(document),
        )
    ) {
        return "BasicDocs";
    }
    if (inclusion.attributes.category === "DOC_REQUIRED") {
        return "AdditionalDocs";
    }
    return null;
};
